import type { FullCharacterPerformanceOptions } from "@sprite-runtime";
import type { CameoHostReaction } from "./prepared-cameos";

type ReactionPlayer = {
  play(options: FullCharacterPerformanceOptions): Promise<unknown>;
  stop(): void;
};

/** The project profile selects the relationship; missing hosts never fall back to another actor. */
export function startCameoHostReaction(
  reaction: CameoHostReaction | undefined,
  players: Readonly<Record<string, ReactionPlayer>>,
  reducedMotion: boolean,
): () => void {
  if (!reaction || reducedMotion || !Object.prototype.hasOwnProperty.call(players, reaction.characterId)) return () => {};
  const player = players[reaction.characterId];
  void player.play({ durationMs: 60000, speechFrames: [{ atMs: 0, frame: "REST" }],
    gestures: [{ atMs: 0, durationMs: 60000, pose: reaction.pose }],
    expressions: [{ atMs: 0, durationMs: 60000, expression: reaction.expression }],
    reducedMotion: false,
  }).catch(() => { /* An unavailable silent reaction must not interrupt the cameo. */ });
  return () => player.stop();
}
